import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that updates only after `delay` ms of no changes.
 * Use in search inputs to avoid re-querying on every keystroke.
 */
export function useDebounced(value, delay = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}
